/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-01-14 11:55:14
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-03-23 10:19:42
 * @Description: file content
 * audio控制中心
 * 用法：
 * $audio.add(name,src); 添加音乐
 * $audio[name].play(options = null, callback); 播放音乐。默认：循环播放。
 * $audio[name].pause(callback); 暂停音乐
 * $audio[name].ended(callback); 播放结束回调
 * $audio[name].getIsPlay(); 获取是否在播放
 */
import wx from '@/services/act-wxjssdk';
let audioList = [];
wx.ready(() => {
  for (let index = 0; index < 100; index++) {
    audioList.push(new Audio());
  }
});

function getAudioFromAudioList() {
  let findAudio = null;
  for (let index = 0; index < audioList.length; index++) {
    const element = audioList[index];
    if (!element.src) {
      findAudio = element;
    }
  }
  return findAudio || null;
}

class MyAudio {
  constructor(name, src) {
    this.name = name;
    this.audio = getAudioFromAudioList();
    if (this.audio) {
      this.audio.preload = "auto";
      this.audio.src = src;
    } else {
      console.warn("audioList数量不足！");
    }
    this.isManualClose = false;
  }

  // 播放配置参数、回调
  play(options = null, callback) {
    if (this.audio && this.audio.src) {
      console.log(`$audio ${this.name} play`, this);
      if (callback) {
        this.audio.addEventListener("playing", () => {
          console.log(`$audio ${this.name} playing 执行回调函数`);
          callback();
        });
      }
      this.audio.loop = true;
      Object.assign(this.audio, options);
      /**
       * readyState返回音频当前的就绪状态。
       * 0 = HAVE_NOTHING - 没有关于音频是否就绪的信息， 微信环境下大于0 即可
        1 = HAVE_METADATA - 关于音频就绪的元数据
        2 = HAVE_CURRENT_DATA - 关于当前播放位置的数据是可用的，但没有足够的数据来播放下一帧/毫秒
        3 = HAVE_FUTURE_DATA - 当前及至少下一帧的数据是可用的
        4 = HAVE_ENOUGH_DATA - 可用数据足以开始播放
       */
      if (this.audio.readyState > 0) {
        this.audio.play();
      } else {
        // 等待加载
        console.log(`$audio ${this.name} play 等待音频就绪`);
        let tmpInterval = setInterval(() => {
          if (this.audio.readyState > 0) {
            console.log(`$audio ${this.name} play 音频已就绪 开始播放`);
            this.audio.play();
            clearInterval(tmpInterval);
          }
        }, 100);
      }
    } else {
      console.warn(`${name}没有audio文件！`);
    }
  }
  //  暂停回调
  pause(callback) {
    if (this.audio && this.audio.src) {
      if (callback) {
        this.audio.addEventListener("pause", () => {
          console.log(`$audio ${this.name} pause 执行回调函数`);
          callback();
        });
      }
      this.audio.pause();
    } else {
      console.warn(`${name}没有audio文件！`)
    }
  }
  // 播放结束回调
  ended(callback) {
    if (this.audio && this.audio.src) {
      if (callback) {
        this.audio.addEventListener("ended", function () {
          console.log(`$audio ${this.name} ended 执行回调函数`);
          callback();
        });
      }
    } else {
      console.warn(`${name}没有audio文件！`)
    }
  }
  // 获取是否在播放状态
  getIsPlay() {
    return this.audio && this.audio.paused;
  }
}

let audioControl = {
  list: [],
  // 添加 音乐名字和路径  $audio[name] 来使用，方法在MyAudio类上
  add: function (name, src) {
    // 检测此name有没有在myAudioList
    let existAudio = null;
    for (let index = 0; index < this.list.length; index++) {
      const element = this.list[index];
      if (element.name == name) {
        existAudio = element;
      }
    }
    if (existAudio) {
      // 修改
      existAudio.src = src;
      console.log(`$audio add ${name} 仅修改路径为 ${src};`, this.list);
    } else {
      // 添加
      let myAudioObj = new MyAudio(name, src);
      this[name] = myAudioObj;
      this.list.push(myAudioObj);
      console.log(`$audio add ${name} 路径为 ${src};`, this.list);
    }
  },
}

let plugin = {};
plugin.install = function (Vue) {
  Vue.prototype.$audio = audioControl;
}
export default plugin;